<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Cita: Especialidad</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">CitaFechaReg</th>
          <th scope="col">EspecialidadNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="especita in datosPaginados" :key="especita.idEspeCita">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(especita.idEspeCita)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(especita.idEspeCita)" title="Editar">edit_square</i></td>
          <td>{{getFormattedDate(especita.citaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{especita.especialidadNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteEspeCita(especita.idEspeCita)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idEspeCita" class="form-label">IdEspeCita</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEspeCita" name="idEspeCita" v-model="datoEspeCita.idEspeCita" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Especialidad -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idEspecialidad" class="form-label"> Especialidad</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEspecialidad" name="idEspecialidad" v-model="datoEspeCita.idEspecialidad">
                      <option v-for="especialidad in especialidads" :value="especialidad.idEspecialidad" :key="especialidad.idEspecialidad">
                        {{ especialidad.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Especialidad -->
<!-- Botón Lista de Valores  Cita -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idCita" class="form-label"> Cita</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idCita" name="idCita" v-model="datoEspeCita.idCita">
                      <option v-for="cita in citas" :value="cita.idCita" :key="cita.idCita">
                        {{ cita.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Cita -->
<!-- Botón Lista de Valores  Medico -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedico" class="form-label"> Medico</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMedico" name="idMedico" v-model="datoEspeCita.idMedico">
                      <option v-for="medico in medicos" :value="medico.idMedico" :key="medico.idMedico">
                        {{ medico.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Medico -->
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarEspeCita" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditEspeCita" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      especitas : [],
      datoEspeCita : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      especialidads: [],
      citas: [],
      medicos: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchEspecialidads()
    this.fetchCitas()
    this.fetchMedicos()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.especitas.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwespecitas/nombre/'+this.nombreBusqueda).then(response=>{
          this.especitas=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.especitas.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwespecitas').then(response=>{
      this.especitas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.especitas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idEspecialidad'
        ,'idCita'
        ,'idMedico'
      ];
      const requiredFieldsText = [
        'idEspecialidad'
        ,'idCita'
        ,'idMedico'
      ];
      return validarForm(this.datoEspeCita, requiredFields, requiredFieldsText);
    },
    async guardarEspeCita(){
      if(this.validarForm() === 1){
        try {
          await api.post('/especitas', this.datoEspeCita)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "EspeCita creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditEspeCita(){
      if(this.validarForm() === 1){
        try {
          await api.post('/especitas', this.datoEspeCita)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "EspeCita creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoEspeCita={}
      this.titulo   = 'Crear Cita: Especialidad'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idEspeCita){
      this.modalWindow = true
      if(idEspeCita != null){    
           api.get('/vwespecitas/'+idEspeCita).then(resp=>{
          this.datoEspeCita = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Cita: Especialidad'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idEspeCita){
      if(idEspeCita != null){
        this.$router.push('/especitamd/'+idEspeCita)
      }
    },
    async deleteEspeCita (idEspeCita) {
      try{
        await api.delete('/especitas/'+idEspeCita)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchEspecialidads() {
      fetch('http://localhost:8080/api/v1/especialidads')
        .then(response => response.json())
        .then(data => {
          this.especialidads = data;
        })
        .catch(error => {
          console.error('Error fetching especialidads:', error);
        });
    },
    fetchCitas() {
      fetch('http://localhost:8080/api/v1/citas')
        .then(response => response.json())
        .then(data => {
          this.citas = data;
        })
        .catch(error => {
          console.error('Error fetching citas:', error);
        });
    },
    fetchMedicos() {
      fetch('http://localhost:8080/api/v1/medicos')
        .then(response => response.json())
        .then(data => {
          this.medicos = data;
        })
        .catch(error => {
          console.error('Error fetching medicos:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
